import { ReactElement} from "react";
import { ContactDetailsModel, ContactKind } from "client/Api/Email/contacts";
import { never } from "client_legacy/ndaw/errors";
import { DetailsForWorkspace } from "./DetailsForWorkspace";
import { DetailsForExchange } from "./DetailsForExchange";

export type DetailsProps = {
	contact: ContactDetailsModel;
};

export const Details = (props: DetailsProps): ReactElement | null => {
	const {
		contact
	} = props;

	switch (contact.kind) {
		case ContactKind.Workspace:
			return <DetailsForWorkspace contact={contact}/>;
		case ContactKind.Exchange:
			return <DetailsForExchange contact={contact} />;
		default:
			return never(contact);
	}
};
Details.displayName="DetailsDialog";